import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTopWindow = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth", // or "auto" for instant scroll
    });
  }, [pathname]);

  return null;
};

export default ScrollToTopWindow;
